const getDisplayName = (sessionUser = {}) =>
  sessionUser.name || sessionUser.email || sessionUser.externalId || '';

export const mapAuthSessionUserToAppUser = (sessionUser) => {
  if (!sessionUser) {
    return null;
  }

  const displayName = getDisplayName(sessionUser);
  const [firstName = '', ...lastNameParts] = displayName.split(' ');

  return {
    id: sessionUser.externalId || sessionUser.email || displayName,
    email: sessionUser.email || '',
    first_name: firstName,
    full_name: displayName,
    last_name: lastNameParts.join(' '),
    picture_url: sessionUser.image || null,
    provider: sessionUser.provider || 'g2',
    partnerAuth: sessionUser.partnerAuth || null,
  };
};

export const mapAuthSessionUserToProfileUser = (sessionUser) => {
  const appUser = mapAuthSessionUserToAppUser(sessionUser);

  if (!appUser) {
    return null;
  }

  return {
    ...appUser,
    my_stack: {
      count: 0,
      list: [],
    },
    saved_apps: {
      count: 0,
      list: [],
    },
  };
};
